var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDuration = function SvgIconDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.225a5.775 5.775 0 1 1 0 11.55 5.775 5.775 0 0 1 0-11.55zm0 1.05a4.724 4.724 0 1 0 0 9.45 4.724 4.724 0 1 0 0-9.45zm-.105 1.648.066.004a.59.59 0 0 1 .506.588v2.7l1.313 1.31.05.059a.634.634 0 0 1-.048.819.618.618 0 0 1-.88.001L6.415 7.917l-.037-.041-.047-.057a.585.585 0 0 1-.113-.344v-2.96l.005-.066a.587.587 0 0 1 .572-.526h.1z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};
export default SvgIconDuration;